import createRibbonViewState from 'owa-editor-ribbonplugin/lib/utils/createRibbonViewState';
import createEditorViewState from 'owa-editor/lib/utils/createEditorViewState';
/**
 * Utility function to get automatic replies state default value
 * @returns instance of AutomaticRepliesOptionState type
 */
export default function getAutomaticRepliesOptionStateDefaultValue() {
    return {
        editorViewStateMessage: createEditorViewState(null /*content*/, false /*isDirty*/),
        editorViewStateDeclineMeeting: createEditorViewState(null /*content*/, false /*isDirty*/),
        editorViewStateOutsideOrg: createEditorViewState(null /*content*/, false /*isDirty*/),
        ribbon: createRibbonViewState(),
        periodicReplyEnabled: null,
        isAutomaticReplyEnabled: null,
        blockCalendarEnabled: null,
        blockCalendarTitle: null,
        declineNewInvitationsEnabled: null,
        declineExistingCalendarEventsEnabled: null,
        sendRepliesToContactsOnlyEnabled: null,
        sendRepliesOutsideOrgEnabled: null,
        startDate: null,
        endDate: null,
        declineMeetingSelectedCategoryKey: null,
        calendarViewItems: [],
    };
}
//# sourceMappingURL=getAutomaticRepliesOptionStateDefaultValue.js.map